import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SportTypeStr } from 'app/services/sport/sport.service';

export type SecretaryJudgeValues = Record<string, number>;

export type FeedbackContentType = 'PLAIN_TEXT' | 'JSON';

export type FeedbackMode = 'TEXT' | 'SCORES_AND_TEXT';

export type FeedbackView = {
  participantName: string;
  eventName: string;
  eventId: number;
  categoryName: string;
  categoryId: number;
  sportType: SportTypeStr;
  pointsSpaBaseUrl: string;
  judgingRulesProfileId?: string | null;
  rounds: {
    roundName: string;
    programs: {
      programType: string;
      performanceId: number;
      showTvsTable: boolean;
      showAvbsTable: boolean;
      resultCategory?: number | null;
      feedbackFields?: string[] | null;
      danceFeedbackMode?: FeedbackMode | null;
      feedbacks: {
        judgeCode: string;
        feedback: string | null;
        contentType?: FeedbackContentType | null;
        judgeValues: SecretaryJudgeValues | null;
      }[];
    }[];
  }[];
};

@Injectable({ providedIn: 'root' })
export class FeedbackService {
  constructor(private http: HttpClient) {}

  getFeedback(token: string): Observable<FeedbackView> {
    return this.http.get<FeedbackView>(`api/public/feedback?token=${encodeURIComponent(token)}`);
  }
}
